import React from "react";
import { useTranslation } from "react-i18next";
import { styled } from "goober";

import { GAME_BOX_ICONS, GAME_PREFERRED_NAME_MAP } from "@/app/constants.mjs";
import type { GameSymbol } from "@/app/games.mjs";

type GameNameIconProps = {
  gameSymbol: GameSymbol;
};

const NameIconWrapper = styled("div")`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  .game-name {
    font-size: 1.75rem;
    text-transform: uppercase;
    font-weight: 800;
    white-space: nowrap;

    @container (inline-size <= 800px) {
      font-size: 1.5rem;
    }
    @container (inline-size <= 600px) {
      font-size: 1.25rem;
    }
  }

  svg {
    --size: 2rem;
    width: var(--size);
    height: var(--size);
    border-radius: var(--br-lg);
    background: var(--game-accent-color);

    @container (inline-size <= 800px) {
      --size: 1.75rem;
    }
    @container (inline-size <= 600px) {
      --size: 1.5rem;
    }

    path {
      fill: var(--shade10);
    }
  }
`;

export default function GameNameIcon({ gameSymbol }: GameNameIconProps) {
  const Icon = GAME_BOX_ICONS[gameSymbol];
  const { t } = useTranslation();

  return (
    <NameIconWrapper>
      <Icon />
      <h1 className="game-name">{t(...GAME_PREFERRED_NAME_MAP[gameSymbol])}</h1>
    </NameIconWrapper>
  );
}
